export default {"src":"/_next/static/media/lecture.dafa212d.svg","height":25,"width":24,"blurWidth":0,"blurHeight":0};